export default __webpack_public_path__ + "static/media/contact-facebook.27ede56f.svg";